export const enum FieldType {
  label = 'LABEL',
  project = 'PROJECT',
  epic = 'EPIC',
  repo = 'REPO',
  custom = 'CUSTOM',
  service = 'SERVICE',
  namePattern = 'NAME_PATTERN',
}
